<template>
  <v-dialog v-model="dialog" persistent max-width="900">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <div
            v-bind="tooltip.attrs"
            v-on="!edit && possuiPropostaEmProcessamento && tooltip.on"
          >
            <v-btn
              v-on="on"
              color="primary"
              class="mr-3"
              :disabled="!edit && possuiPropostaEmProcessamento"
            >
              <slot name="title"></slot>
            </v-btn>
          </div>
        </template>
        Não é possível gerar nova proposta, devido à existência de uma
        em processamento.
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="fechar" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h3>
              Para {{ !edit ? "gerar" : "editar" }} uma proposta, adicione os
              eixos e soluções abaixo.
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>
              <strong>Pacote Essencial: </strong> 2 Eixos do Ambiente de
              Negócios + 1 Eixo Estratégico.
            </div>
            <div>
              <strong>Pacote Premium:</strong> 2 Eixos do Ambiente de Negócios +
              2 Eixos Estratégicos.
            </div>
            <div>
              <strong>Pacote Ultimate:</strong> 2 Eixos do Ambiente de Negócios
              + 3 Eixos Estratégicos.
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            ><ComboboxGroupSolution
              :filter="{
                grupoSolucaoId: atualGrupoSolucao,
              }"
              :mostrarTipo="true"
              :title="'Eixos'"
              @changeGroupSolution="changeGroupSolution"
              :maximoEixos="maximoEixos"
            ></ComboboxGroupSolution>
          </v-col>
          <v-col v-if="atualGrupoSolucao">
            <ComboboxSolution
              :filter="{
                solutions: atualSolutions,
                solucaoId: selectedSolutions,
              }"
              multiple
              @changeSolution="changeSolution"
              returnObject
              :solutionIds="[]"
            ></ComboboxSolution>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="selectedSolutions"
              class="elevation-1 w-100 proposta"
              hide-default-footer
              disable-pagination
              fixed-header
            >
              <template v-slot:item.acoes="{ item }">
                <v-btn
                  outlined
                  color="error"
                  class="mr-3"
                  @click="deleteProposta(item)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-btn color="primary" class="mr-3" @click="duplicar(item)">
                  Duplicar
                </v-btn>
              </template>

              <template slot="no-data">
                <span> Nenhum eixo adicionado </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="text-align: center; font-size: 20px">
            <div>
              <strong>{{ pacoteAtual }} </strong>
            </div>
          </v-col>
        </v-row>
        <TabelaValores
          :payload="{ ...payload, solucoesFaixasDTO: selectedSolutions }"
          :faixa="faixa"
          :combos="combos"
          :onlyTotal="true"
        ></TabelaValores>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="fechar">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">
          <slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ComboboxGroupSolution from "@/modules/group-solution/components/Combobox.vue";
import ComboboxSolution from "@/modules/solution/components/Combobox.vue";
import { solutionAPI } from "@/modules/solution/components/SolutionAPI";
import { propostaApi } from "@/apis/proposta";
import { statusPropostasEnum } from "@/modules/city/components/propostas/statusPropostasEnum.js";
import moment from "moment";
import { CombosEnum } from "@/modules/city/components/propostas/CombosEnum";
import TabelaValores from "@/modules/city/components/propostas/ma/TabelaValoresMA.vue";
import PacotesEnum from "@/modules/city/components/propostas/ma/pacotesEnum";

export default {
  name: "ModalNovaPropostaMA",
  components: {
    ComboboxGroupSolution,
    ComboboxSolution,
    TabelaValores,
  },
  props: {
    payload: { type: Object, required: true },
    edit: { type: Object, default: () => {} },
    possuiPropostaEmProcessamento: { type: Boolean, default: false },
    combos: {
      type: Array,
      default: () => [],
    },
    faixa: { type: Object, default: null },
    solucoesExtras: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(["isFullAdmin", "city", "user"]),
    solucaoEscolhida() {},
    combosEssecialSolutionsId() {
      const comboEssencial =
        this.combos &&
        this.combos.length &&
        this.combos.find(
          (item) => (item.municipioPropostaCombosId = CombosEnum.essencial)
        );

      return (
        (comboEssencial &&
          comboEssencial.solucaoIds &&
          comboEssencial.solucaoIds.split(",")) ||
        []
      );
    },
    ultrapassouValorTeto() {
      return this.faixa && this.faixa.faixaTeto < this.getValorTotal;
    },
    getExcedenteTeto() {
      return this.getValorTotal - this.getValorTeto;
    },
    getValorTotal() {
      const sum = this.getSomaSolucoes;

      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;
      return sum + valorEssencial;
    },
    getSomaSolucoes() {
      return this.selectedSolutions.reduce((partialSum, a) => {
        return partialSum + (a.precoFaixa || 0);
      }, 0);
    },
    faixaSubsidioPreium() {
      return (this.faixa && this.faixa.subsidioPremium) || 0;
    },
    faixaSubsidio() {
      return (this.faixa && this.faixa.faixaSubsidio) || 0;
    },
    getValorTotal() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      return this.getSomaSolucoes + valorEssencial;
    },
    getValorEssencial() {
      return (this.faixa && this.faixa.valorFaixaEssencial) || 0;
    },
    getValorTeto() {
      return (this.faixa && this.faixa.faixaTeto) || 0;
    },
    getValorSolucoesPorTeto() {
      //  o valor excedente do teto da faixa da proposta é entrado integralmente no investimento do municipio
      if (this.ultrapassouValorTeto) {
        return {
          valorSolucaoAteTeto:
            this.getValorTotal - this.getValorEssencial - this.getExcedenteTeto,
          valorSolucaoAposTeto: this.getExcedenteTeto,
        };
      }

      return {
        valorSolucaoAteTeto: this.getSomaSolucoes,
        valorSolucaoAposTeto: 0,
      };
    },
    getValorContrapartidaSebrae() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio = valorEssencial * (this.faixaSubsidio / 100);

      const valorComSubsidioPremium =
        this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
        (this.faixaSubsidioPreium / 100);

      return valorComSubsidio + valorComSubsidioPremium;
    },
    getValorInvestimentoMunicipal() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio =
        valorEssencial * ((100 - this.faixaSubsidio) / 100);

      const valorComSubsidioPremium =
        this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
        ((100 - this.faixaSubsidioPreium) / 100);

      return (
        valorComSubsidio +
        valorComSubsidioPremium +
        this.getValorSolucoesPorTeto.valorSolucaoAposTeto
      );
    },
    eixosEscolhidos() {
      let a = [];

      if (this.selectedSolutions && this.selectedSolutions.length > 0)
        a = this.selectedSolutions.reduce((acc, item) => {
          if (
            !acc.some(
              (obj) => obj && item && obj.grupoSolucaoId === item.grupoSolucaoId
            )
          ) {
            acc.push(item);
          }
          return acc;
        }, []);

      return a;
    },
    maximoEixos() {
      //o máximo de eixos são 5, idependentes da solução

      return this.eixosEscolhidos.map((val) => val.grupoSolucaoId);
    },
    pacoteAtual() {
      let pacote = "Nenhum Pacote";

      if (this.eixosEscolhidos && this.eixosEscolhidos.length) {
        const qtdNegocios = this.eixosEscolhidos.filter((item) => {
          return item.grupoSolucao.tipo == PacotesEnum.negocios;
        });
        const qtdEstrategico = this.eixosEscolhidos.filter(
          (item) => item.grupoSolucao.tipo == PacotesEnum.estrategico
        );
        if (qtdNegocios.length == 2 && qtdEstrategico.length == 1)
          pacote = "Pacote Essencial";
        else if (qtdNegocios.length == 2 && qtdEstrategico.length == 2)
          pacote = "Pacote Premium";
        else if (qtdNegocios.length == 2 && qtdEstrategico.length == 3)
          pacote = "Pacote Ultimate";
      }

      return pacote;
    },
  },
  watch: {
    dialog(val) {
      if (val && !!this.edit) {
        this.loadSolutions();
      }
    },
  },
  data() {
    return {
      dialog: false,
      atualGrupoSolucao: null,
      atualSolutions: [],
      solutions: [],
      pacotesEnum: PacotesEnum,
      selectedSolutions: [],
      novaProposta: { groupSolution: [] },
      headersValores: [
        { text: "", value: "combo", sortable: false },
        {
          text: "Investimento Total",
          value: "investimentoTotal",
          sortable: false,
        },
        {
          text: "Contrapartida Sebrae",
          value: "contrapartidaSebrae",
          sortable: false,
        },
        {
          text: "Investimento Municipal",
          value: "investimentoMunicipal",
          sortable: false,
        },
      ],

      headers: [
        { text: "Grupo", value: "grupoSolucao.nome", align: "center" },
        { text: "Tipo", value: "grupoSolucao.tipo", align: "center" },
        { text: "Solução", value: "nome", align: "center" },
        { text: "Ações", value: "acoes", align: "center" },
      ],
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    duplicar(val) {
      const qd = this.selectedSolutions.filter(
        (item) => item.solucaoId === val.solucaoId
      ).length;

      this.selectedSolutions.push({
        ...val,
        nome: `${val.nome} ${qd + 1}`,
      });
    },
    addSolucao(val) {
      this.selectedSolutions = val.municipioPropostaGrupoSolucaoDTO
        .map((id) =>
          this.solutions.find((item) => item.solucaoId === id.idSolucao)
        )
        .filter((i) => i && i.solucaoId);
      const solucoesExtra = val.municipioPropostaGrupoSolucaoDTO
        .map((item) =>
          this.solucoesExtras.find(
            (v) => item.solucaoExtraId == v.municipioPropostaSolucoesExtrasId
          )
        )
        .filter((i) => i && i.municipioPropostaSolucoesExtrasId);

      this.selectedSolutions = [...this.selectedSolutions, ...solucoesExtra];

      const solucoesPrecos =
        (this.faixa &&
          this.faixa.solucoesFaixasDTO &&
          this.faixa.solucoesFaixasDTO.length &&
          this.faixa.solucoesFaixasDTO) ||
        [];

      this.selectedSolutions = this.selectedSolutions.map((val) => {
        const solucaoAtual = solucoesPrecos.find(
          (a) => a.solucaoId == val.solucaoId
        );

        return {
          ...val,
          precoFaixa:
            (solucaoAtual && solucaoAtual.preco) || val.preco || undefined,
          custoFaixa:
            (solucaoAtual && solucaoAtual.custo) || val.custo || undefined,
          solucaoFaixaid:
            (solucaoAtual && solucaoAtual.solucaoFaixaid) || undefined,
        };
      });
    },
    onConfirm() {
      this.setLoading(true);
      var proposta = {
        municipioId: this.$route.params.id,
        usuarioCriacao: this.user.usuarioId,
        valorTotal: this.getValorTotal,
        status: statusPropostasEnum.emProcessamento,
        municipioPropostaGrupoSolucaoDTO: this.selectedSolutions.map(
          (item) => ({
            idSolucao: item.solucaoId,
            idGrupoSolucao:
              (item.grupoSolucao && item.grupoSolucao.grupoSolucaoId) ||
              item.grupoSolucaoId,
            solucaoExtraId: item.municipioPropostaSolucoesExtrasId,
          })
        ),
        contrapartidaSebrae: this.getValorContrapartidaSebrae,
        investimentoMunicipio: this.getValorInvestimentoMunicipal,
      };

      propostaApi
        .gerarProposta(proposta)
        .then((data) => {
          this.fazerDownloadRelatorio(data.data, `Proposta - ${this.city}`);
        })
        .catch((err) => {
          this.$notification.error("Erro ao gerar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    rejeitarProposta(item) {
      item.status = statusPropostasEnum.rejeitado;
      propostaApi
        .update(item)
        .then(() => {
          console.log("aqui");
          // this.$notification.success("Proposta revertida com sucesso");
          this.$emit("onLoad");
          this.dialog = false;
        })
        .catch((err) => {
          //this.$notification.error("Erro ao reverter Proposta");
          console.log("Erro no cancelar ", err);
          this.setLoading(false);
        });
    },
    deleteProposta(item) {
      this.selectedSolutions = this.selectedSolutions.filter(
        (val) => item !== val
      );
    },
    changeSolution(solutions) {
      this.selectedSolutions = solutions.reverse();
    },
    loadSolutions() {
      solutionAPI.list({}).then((res) => {
        this.solutions = res.data;
        // this.edit.municipioPropostaGrupoSolucaoDTO = this.mockado;
        this.addSolucao(this.edit);
      });
    },
    addPreco(data, solucoesExtras) {
      const solucoesPrecos =
        (this.faixa &&
          this.faixa.solucoesFaixasDTO &&
          this.faixa.solucoesFaixasDTO.length &&
          this.faixa.solucoesFaixasDTO) ||
        [];

      this.atualSolutions = data.filter(
        (val) =>
          !this.combosEssecialSolutionsId.some((ob) => val.solucaoId == ob)
      );

      this.atualSolutions = data.filter((val) =>
        solucoesPrecos.some((item) => item.solucaoId == val.solucaoId)
      );

      this.atualSolutions = [...this.atualSolutions, ...solucoesExtras];

      if (this.atualSolutions && this.atualSolutions.length) {
        this.atualSolutions = this.atualSolutions.map((val) => {
          const solucaoAtual = solucoesPrecos.find(
            (a) => a.solucaoId == val.solucaoId
          );

          return {
            ...val,
            precoFaixa:
              (solucaoAtual && solucaoAtual.preco) || val.preco || undefined,
            custoFaixa:
              (solucaoAtual && solucaoAtual.custo) || val.preco || undefined,
            solucaoFaixaid:
              (solucaoAtual && solucaoAtual.solucaoFaixaid) || undefined,
          };
        });
      }
    },
    async loadSolutionsByGroup(val) {
      try {
        this.atualSolutions = [];
        const data = await solutionAPI.getSolutions([val]);

        let solucoesExtrasGrupo = [];

        if (this.solucoesExtras && this.solucoesExtras.length > 0) {
          solucoesExtrasGrupo = this.solucoesExtras.filter(
            (item) => val == item.grupoSolucaoId
          );
        }

        this.addPreco(data.data, solucoesExtrasGrupo);
      } catch (error) {
        console.log("🚀 ~ loadSolutionsByGroup ~ error:", error);
      }
    },
    fazerDownloadRelatorio(file, nomeArquivo) {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `${nomeArquivo} - ${moment().format("DD.MM.YYYY.HH.mm")}.pdf`
      );

      document.body.appendChild(fileLink);
      fileLink.click();

      if (this.edit) this.rejeitarProposta(this.edit);
      else {
        this.$notification.success("Proposta gerada com sucesso!");

        this.$emit("onLoad");
        this.dialog = false;
        this.setLoading(false);
      }
    },
    changeGroupSolution(grupoSolucaoId) {
      this.atualGrupoSolucao = grupoSolucaoId;
      this.loadSolutionsByGroup(this.atualGrupoSolucao);
    },
    fechar() {
      if (!this.edit) {
        this.selectedSolutions = [];
        this.atualGrupoSolucao = null;
      }

      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.comboEssencial {
  color: var(--corPrimaria);
  cursor: pointer;
}
.combo {
  .header {
    background: black;
    margin-left: -28px;
    width: 135%;
    text-align: center;
    margin-top: -16px;
    margin-bottom: 5px;
  }
}
</style>
